export default __webpack_public_path__ + "static/media/Slide38.8887185e.PNG";